<template>
  <div id="login-wrapper">
    <div id="login-screen-holder">
      <div id="login-screen" class="shadow">
        <img src="../../assets/logo-bird.svg">

        <form v-on:submit="login()">
          <input type="text" v-model="email" placeholder="E-mail" class="shadow"/><br/><br/>
          <button class="button button-lg shadow">{{$t('reset-password')}}</button>
        </form>

        <p>
          <router-link to="/login">{{$t('login-anyway')}}</router-link>
          {{$t('or')}}
          <router-link to="/register">{{$t('no-account')}}</router-link>?
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ForgotPassword',

  data() {
    return {
      email: '',
    };
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  #login-wrapper {
    position: fixed;
    width: 100%;
    height: 100%;
    background: url("../../assets/login-bg.svg") no-repeat center;
    background-size: cover;
    padding: 0;
    margin: -35px 0 0  -350px;
    display: table;
  }

  #login-screen-holder {
    display: table-cell;
    vertical-align: middle;
  }

  #login-screen {
    background: white;
    width: 400px;
    padding: 40px 30px;
    margin: auto;
    text-align: center;
    border-radius: 10px;
  }

  #login-screen img {
    max-width: 60px;
    transform: rotate(45deg);
  }

  #login-screen form {
    padding-top: 40px;
  }

  #login-screen input {
    width: 250px;
    padding: 15px 25px;
    border-radius: 5px;
    border: 0;
    outline: 0;
    font-size: 14px;
    font-weight: 400;
    color: #6C6C6C;
  }

  #login-screen input::placeholder {
    color: #BFD0FF;
  }

  #login-screen button {
    width: 300px;
    padding: 15px 40px;
  }

  #login-screen p {
    margin-top: 50px;
    font-size: 12px;
    margin-bottom: -20px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/authentication/ForgotPassword.vue